import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    CreateCheckinSettings,
    UpdateCheckinSettings,
} from "@/types/booking-checkin-settings";
import { bookingCheckinSettingsService } from "@/services/ServiceRegistry";

export const checkinSettingsKeys = {
    all: ["checkin-settings"] as const,
    details: () => [...checkinSettingsKeys.all, "detail"] as const,
};

export const useBookingCheckinSettings = () => {
    return useQuery({
        queryKey: checkinSettingsKeys.details(),
        queryFn: () => bookingCheckinSettingsService.getSettings(),
    });
};

export const useCreateBookingCheckinSettings = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateCheckinSettings) =>
            bookingCheckinSettingsService.createSettings(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: checkinSettingsKeys.details() });
        },
    });
};

export const useUpdateBookingCheckinSettings = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: UpdateCheckinSettings) =>
            bookingCheckinSettingsService.updateSettings(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: checkinSettingsKeys.details() });
        },
    });
};
